import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialGamblingModel } from './types';
import { financialGamblingItemValidator } from './validators/item';

const financialGamblingValidator: ValidateJSModel<FinancialGamblingModel> = {
  HasGamblingDebt: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasGamblingDebt?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialGamblingItemValidator },
      };
    }

    return {};
  },
};

export default financialGamblingValidator;
